import { render } from "./SuccessMailModal.vue?vue&type=template&id=3c2071aa"
import script from "./SuccessMailModal.vue?vue&type=script&lang=js"
export * from "./SuccessMailModal.vue?vue&type=script&lang=js"
script.render = render

export default script